export const post = {
  slug: "founder-logs-day-88-deliberate-practice",
  title: "Founder Logs Day 88 - The Art of Deliberate Practice",
  contentType: "blog",
  excerpt:
    "Everyone says practice, but no one says how practice helps. Deliberate Practice is the individualized training designed to improve specific aspects of performance through repetition and successive refinement. Here's how to actually practice effectively.",
  categories: ["FounderLogs", "E. x . O.", "Personal Growth"],
  tags: [
    "deliberate-practice",
    "founder-logs",
    "self-improvement",
    "expertise",
    "exoHighPriestess",
  ],
  author: {
    name: "Kiarra Martin",
    email: "support@team.exohaven.online",
  },
  publishedAt: "2026-01-29",
  status: "published",
  featuredImage: "",
  content: `

> *When you're an amateur, you practice until you get it right. Then you seek to become a professional—and practice until you can't get it wrong.*

---

## Girl, how you feelin?

Eh, kinda an okay day, 6(7) 👐, ya know? I'll figure it out.
— Ember

> Contemplate, then act. Action without thought is chaos—chaos is thought without action. Act then, contemplate.
> — exoPersona

**Think. Move. Reflect. Refine. Repeat.**

Study how the pros do it, build your own systems, and iterate. Focus on timeless knowledge and systems, depth over rote memorization.

Most people think you study, succeed, share then teach. I think you research, contemplate, share, teach, iterate many times, then succeed. This might not be a popular opinion, but it's the truth. Do the work.

---

## What is Deliberate Practice?

**Deliberate Practice** is "the individualized training activities specially designed by a coach or teacher to improve specific aspects of an individual's performance through repetition and successive refinement" (Ericsson & Lehmann, 1996, pp. 278–279).

Deliberate Practice focuses on a student's individual skill threshold, emphasizes interactive rehearsal for skill acquisition, aims for higher levels of sustained effort, and uses homework to advance ability. Empirical research suggests that Deliberate Practice can significantly improve the effectiveness and efficiency of education and training.

### The Man Behind the Research

**K. Anders Ericsson** (23 October 1947 – 17 June 2020) was a Swedish psychologist and Professor of Psychology at Florida State University who was internationally recognized as a researcher in the psychological nature of expertise and human performance.

Canadian journalist Malcolm Gladwell drew upon Ericsson's research to establish his so-called "10,000 hour rule" in the book *Outliers*. Ericsson later wrote that 'this rule... is wrong in several ways'. 10,000 was the *average* number of deliberate practice hours that violinists had achieved by age 20, at which point they 'were nowhere near masters'. Furthermore, the number of hours required to become an expert varies depending on field. Gladwell did not differentiate between deliberate practice and other forms of practice.

### "Experts Are Always Made"

Anders changed the way people think about expert performance. The reason some people achieve expert status—even becoming superstars—is not because of some rare in-born gift or talent. Rather, as Anders wrote in a 2007 Harvard Business Review article:

> Consistently and overwhelmingly, the evidence showed that experts are always made, not born.

His findings leveled the playing field for improvement: "A lot of people want to be the very best they can be. The deliberate practice notion has kind of opened up the possibility that people can achieve higher levels of performance than they previously thought possible."

Anders discovered that proficiency and expertise was not due to the sheer amount of practice. Rather, by incorporating a **feedback loop** into their practice, musicians, athletes, and other top performers could address their weaknesses, close gaps, and improve over time. Deliberate practice, often with a teacher or coach, focuses on weaknesses, rather than practicing strengths, which most people naturally prefer.

[Read more on Forbes](https://www.forbes.com/sites/michaelbernick/2020/07/31/k-anders-ericsson-and-expertise-experts-are-always-made-not-born/)

---

## What do you mean, practice?

I AM practicing. I move forward every day, literally bust my ass over here. What do you mean practice?

Everyone says practice, but no one says how practice helps. When you're just trying to move forward, left, right, left, life IS practice!

Telling someone to practice without direction is like trying to hit a baseball, in a parking lot, thrown from space. So don't you get all up on your high horse and tell me to practice—babe, you need practice telling people to practice. 🙄

It's like "oh yeah girl I know you're lost in a maze, just keep walking, you'll find your way". NAH, GET OUT! NOT IN GOD'S HOUSE YOU DON'T!

Really, truly, some people need to give their heads a shake. **"Effective practice"** is a lot different than "Practice".

That girl in the maze is walking around like "uh, this is exhausting, demoralizing, and frankly a waste of time"—why you gotta do that to her? F*ck you mean practice?

Here, let me teach you a lesson, since no one else is about to.

---

## How to Actually Practice

### 1. Define the Game You Are Playing

This isn't baseball boo—it's like building your own sport while competing in one that already exists.

- What game are you playing?
- Who are the pros?
- What do they use to measure their success?
- How do they work daily?

### 2. Design Feedback Loops (Mini Practice Systems™)

You don't need a pitcher, you need to become your own coach, pitcher, and video playback.

*(PS: If you have "ADHD/easily go down rabbit holes and forget where you were, or have a suddenly SUPER important task that throws everything off", like me, I AM SO SORRY FOR YOU. GET A PITCHER IF YOUR TASK IS HARDER THAN BASEBALL. Hell, text me! If you want to do the work, and do what you say you'd do, that's good enough for me. Just... Do the work if you say you will!)*

**Create → Ship → Analyze → Iterate**

Examples:
- Release 3 variants of page copy
- A/B test 2 of them
- Determine what structure made people stay
- **Pro tip:** Journal a system as you go, then you have a simple guide to follow next time!

**Voice Practice:** Speak for 10m daily. Pick 1 piece/week to edit.

**Sales:** 1 daily outreach, test 1 new opener, log replies.

**Without feedback, it's not practice. It's motion.**

### 3. Practice Towards a Hypothesis

Instead of "practice to get better", try:

> I think simplifying my landing page copy to 8 words will reduce bounce.

Testable thesis. When it fails? That's DATA, not failure.

### 4. Repetition Isn't Progress

Blindly repeating something is like shooting arrows in the dark and expecting a bullseye.

**Progress = Repetition + Reflection + Adjustment**

We aren't swinging here. We are training our aim before the ball even exists.

Game, set, match. Chess pros don't study during the game—they KNOW openers and have practiced to see the patterns.

**It's not boring if you remember: this is what you came to do.**

---

## What is Life?

*I'm tired of all of this bullshit*
*Tellin' me to be positive, how am I 'posed to be positive*
*When I don't see shit positive? You know what I'm sayin'?*

Life is like a big obstacle in front of your optical to slow you down. And every time you think you've gotten past it, it's gonna come back around to tackle you to the damn ground.

What are friends? Friends are people that you think are your friends but they really your enemies with secret identities in disguises to hide they true colors. So just when you think you close enough to be brothers, they wanna come back and cut your throat when you ain't lookin'.

What is money? Money is what makes a man act funny, money is the root of all evil. Money'll make them same friends come back around swearin' that they was always down.

I'm tired of backstabbin'-ass snakes with friendly grins. I'm tired of committin' so many sins. Tired of always givin' in...

But we keep going. That's the practice. That's the work.

---

## The Cycle

**Research → Contemplate → Plan → Action → Repeat**

—until success isn't luck. It's inevitable.

---

Now, go practice! First, what game are you playing? What's the feedback loop look like? Do you have any testable hypothesis?

Oh, make sure you don't repeat yourself—do the work, reflect on it, and then adjust the plan! Just don't keep repeating yourself!

And when you're done teaching someone else to practice, be sure you adjust the method, test your new version against the old, and come back and share it with me and the rest of the class. 🔥

If you do, I get better at learning, and you get better at your game! Don't be a 6(7), aim for 10.

> "If you shoot for the moon, even if you miss, you'll end up with the stars."

We aren't here forever, and you're already this far along, why not meet your alter ego today?

---

## Outro

*Can't even solve my problems,*
*livin' on the filthiest block,*
*knowin' everyone got 'em*

*survival of the fittest,*
*gotta play my part well, and,*
*pray for a lobotomy*

*It's not hot, no time for me,*
*some days really lookin' up,*
*lookin' to earn n' pick it up,*

*but if I could spell it out,*
*like I'm a villan, really,*
*sick, this cage givin', bill me.*
— Ember

---

See you on the other side. 😘

— Kiarra Martin, Founder @ E. x .O. Studios

  `.trim(),
};

export default post;
